import { Button, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { useParentPasscodeModalStore } from "../useParentPasscodeModalStore"

const ConfirmDeletePasscode = ({ onDelete }: { onDelete: () => void }) => {
  const { onClose } = useParentPasscodeModalStore()
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-4">
      <Typography variant="bodyBold">{t("PPC_ARE_YOU_SURE")}</Typography>
      <Typography variant="bodySmall">{t("PPC_DELETE_DESC")}</Typography>
      <div className="flex flex-row gap-4">
        <Button
          buttonType="secondary"
          text={t("QB_CANCEL")}
          onClick={onClose}
          fullWidth
        />
        <Button
          buttonType="redPrimary"
          text={t("PPC_TURN_OFF")}
          onClick={onDelete}
          fullWidth
        />
      </div>
    </div>
  )
}

export default ConfirmDeletePasscode
